import { restApi } from '../../api';
import {
  OAuthConsentDetailsResponse,
  OAuthLoginDiscoverParams,
  OAuthLoginDiscoverResponse,
} from './oauth.types';

export const discoverOAuthLogin = (data: OAuthLoginDiscoverParams) =>
  restApi.post<OAuthLoginDiscoverResponse>('/oauth/login/discover', data);

export const getOAuthConsent = (oauthRequestId: string) =>
  restApi.get<OAuthConsentDetailsResponse>(
    '/oauth/consent',
    { oauth_request_id: oauthRequestId },
    { withCredentials: true },
  );
